import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { useOpenWebVoice } from '#pplx/frontend/apps/ask/multimodal/voice/launcher/useOpenWebVoice.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { sanitizeUrl } from '#pplx/frontend/common/files/urls.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
const messages = defineMessages({
    loginPitchDescription: {
        defaultMessage: 'Ask anything out loud and get instant, cited answers.',
        description: 'Description of the login prompt shown when a signed-out user opens voice mode',
        id: '09b8244a56',
    },
    loginPitchTitle: {
        defaultMessage: 'Sign in to use voice mode',
        description: 'Title of the login prompt shown when a signed-out user opens voice mode',
        id: '659bdb0692',
    },
});
const LoginModal = Dynamic(async () => {
    const { LoginModal } = await import('#pplx/frontend/apps/ask/auth/login/LoginModal.js');
    return { default: LoginModal };
});
export function useOpenVoiceToVoice() {
    const { $t } = useIntl();
    const { openModal } = useModalContext();
    const isUserLoggedIn = useIsUserLoggedIn();
    const router = useRouter();
    const openWebVoice = useOpenWebVoice();
    return useCallback(() => {
        if (!isUserLoggedIn && import.meta.env.VITE_IS_SIDECAR_BUILD) {
            window.open(sanitizeUrl('/auth/signin'), '_blank');
        }
        else if (!isUserLoggedIn) {
            openModal(LoginModal, {
                origin: ModalOrigin.VOICE_TO_VOICE_BUTTON,
                pitchMessage: {
                    title: $t(messages.loginPitchTitle),
                    description: $t(messages.loginPitchDescription),
                },
            }, { replace: true });
        }
        else if (import.meta.env.VITE_IS_SIDECAR_BUILD) {
            router.push('/speak');
        }
        else {
            openWebVoice();
        }
    }, [$t, isUserLoggedIn, openModal, openWebVoice, router]);
}
//# sourceMappingURL=useOpenVoiceToVoice.js.map